import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDataWAuth, postDataWAuth, putDataWAuth, deleteDataWAuth } from "../../../utils/api-service";
import {
  DEALER_DETAILS_URI,
  ADD_DEALER_DETAILS,
  UPDATE_DEALER_DETIALS,
  DELETE_DEALER_DETAILS,
} from "../../../constants/constant";

export const fetchDealers = createAsyncThunk(
  "dealers/fetchDealers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDataWAuth(DEALER_DETAILS_URI);
      return response.data || [];
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch dealers");
    }
  }
);

export const createDealer = createAsyncThunk(
  "dealers/createDealer",
  async (dealerData, { rejectWithValue }) => {
    try {
      const response = await postDataWAuth(ADD_DEALER_DETAILS, dealerData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to create dealer");
    }
  }
);

export const updateDealer = createAsyncThunk(
  "dealers/updateDealer",
  async ({ dealerData, id }, { rejectWithValue }) => {
    try {
      const response = await putDataWAuth(UPDATE_DEALER_DETIALS, dealerData, { id });
      return { data: response.data, id };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to update dealer");
    }
  }
);

export const deleteDealer = createAsyncThunk(
  "dealers/deleteDealer",
  async (dealerId, { rejectWithValue }) => {
    try {
      await deleteDataWAuth(DELETE_DEALER_DETAILS, { id: dealerId });
      return dealerId;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to delete dealer");
    }
  }
);

const initialState = {
  dealers: [],
  loading: false,
  actionLoading: false,
  error: null,
};

const dealersSlice = createSlice({
  name: "dealers",
  initialState,
  reducers: {
    clearDealersError: (state) => {
      state.error = null;
    },
    resetDealers: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDealers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDealers.fulfilled, (state, action) => {
        state.loading = false;
        state.dealers = action.payload;
      })
      .addCase(fetchDealers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(createDealer.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
      })
      .addCase(createDealer.fulfilled, (state, action) => {
        state.actionLoading = false;
      })
      .addCase(createDealer.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      });

    builder
      .addCase(updateDealer.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
      })
      .addCase(updateDealer.fulfilled, (state, action) => {
        state.actionLoading = false;
      })
      .addCase(updateDealer.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      });

    builder
      .addCase(deleteDealer.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
      })
      .addCase(deleteDealer.fulfilled, (state, action) => {
        state.actionLoading = false;
        state.dealers = state.dealers.filter(dealer => dealer.id !== action.payload);
      })
      .addCase(deleteDealer.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDealersError, resetDealers } = dealersSlice.actions;
export default dealersSlice.reducer;
